import { mapL } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
export const checkAreaEnclosure = ({ points1, points2 }) => {
  const [
    { min_x: min_x1, min_y: min_y1, max_x: max_x1, max_y: max_y1 },
    { min_x: min_x2, min_y: min_y2, max_x: max_x2, max_y: max_y2 },
  ] = mapL(CommonNS.UtilNS.calculateMinMaxXY)([points1, points2]);
  return (
    (min_x1 >= min_x2 &&
      max_x1 <= max_x2 &&
      min_y1 >= min_y2 &&
      max_y1 <= max_y2) ||
    (min_x2 >= min_x1 &&
      max_x2 <= max_x1 &&
      min_y2 >= min_y1 &&
      max_y2 <= max_y1)
  );
};
